import type { ReactNode } from "react";
import { cn } from "./cn";
import { Ikon, type IkonAdi } from "./Ikon";

export type BosDurumTonu = "notr" | "hata";

export interface BosDurumProps {
  baslik: string;
  aciklama?: string;
  eylem?: ReactNode;
  /**
   * BOS MU, BOZUK MU?
   *
   * ================================================================
   * BU IKISI AYNI SEY DEGIL VE AYNI GORUNMEMELI
   * ================================================================
   * "Deneme yok" ile "Denemeler alinamadi" bu bilesende birebir ayni
   * ciziliyordu: ayni kesikli kutu, ayni gri metin. Kullanicinin
   * gordugu tek fark bir cumleydi ve o cumle de sakin bir tonda
   * yaziliydi.
   *
   * Fark onemli cunku YAPILACAK SEY farkli: bosluk BEKLENIYOR ve
   * cozumu veri girmek; ariza beklenmiyor ve cozumu tekrar denemek
   * ya da haber vermek. Ilki normal, ikincisi degil.
   *
   * "Olculmedi ≠ sifir" kuralinin gorsel karsiligi bu.
   */
  ton?: BosDurumTonu;
  /**
   * Durumu anlatan simge. Varsayilan tondan geliyor.
   *
   * Varsayilan var cunku boslugun kendisi bir durum: 20 kusur cagri
   * yerinin cogunda dogru cevap zaten ayni. Ama bazi bos durumlar
   * IYI HABER — "bekleyen is yok" gibi. Onlar simgesini acikca secsin.
   */
  ikon?: IkonAdi;
}

const TON_SINIFI: Record<BosDurumTonu, { kenar: string; simge: string }> = {
  notr: { kenar: "border-notr-300", simge: "text-notr-300" },
  /*
    Hata tonunda kenar da kirmiziya donuyor. RENK TEK SINYAL DEGIL:
    simge de degisiyor, baslik zaten "...alinamadi" diyor ve cogu
    cagri yerinde bir "Tekrar dene" dugmesi duruyor. Renk yalnizca en
    hizli fark edilen sinyal, tek fark edilen degil.
  */
  hata: { kenar: "border-hata-500/40", simge: "text-hata-500/70" },
};

const VARSAYILAN_IKON: Record<BosDurumTonu, IkonAdi> = {
  notr: "bos",
  hata: "uyari",
};

/**
 * Bos durum bileseni.
 *
 * Sistem SIFIRDAN acilir ve hicbir yerden veri aktarilmaz — yani ilk
 * haftalarda kullanicinin gorecegi ekranlarin cogu BOS olacak. Bos ekran
 * "bir sey bozuldu" hissi verir; bu bilesen ne oldugunu ve sirada ne
 * yapilacagini soyler.
 */
export function BosDurum({ baslik, aciklama, eylem, ton = "notr", ikon }: BosDurumProps) {
  const g = TON_SINIFI[ton];
  return (
    /*
      KESIKLI KENAR BILEREK: dolu bir kartla ayni gorunseydi kullanici
      "icerik var ama yuklenmemis" sanardi. Kesikli kenar "burasi
      henuz doldurulmadi" demenin gorsel karsiligi.
    */
    <div
      className={cn(
        "belir rounded-kart flex flex-col items-center justify-center gap-3 border border-dashed px-6 py-12 text-center",
        g.kenar,
      )}
    >
      {/*
        SIMGE SOLUK: dikkat cekmesi degil, bosluga bir MERKEZ vermesi
        isteniyor. Tamamen bos bir dikdortgende goz nereye bakacagini
        bilemiyor ve ekran "yuklenmemis" gibi duruyor.

        `Ikon` zaten `aria-hidden`; anlami tasiyan sey basligin metni.
      */}
      <Ikon ad={ikon ?? VARSAYILAN_IKON[ton]} boyut="buyuk" className={g.simge} />
      <p className="text-notr-800 text-base font-medium">{baslik}</p>
      {aciklama && <p className="text-notr-600 max-w-sm text-sm">{aciklama}</p>}
      {eylem}
    </div>
  );
}
